(function () {
	'use strict';

	angular.module('formonlineApp')
			.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('app', {
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-12'
			},
			views: {
				'navbar@': {
					templateUrl: 'scripts/app/layouts/navbar/navbar.html',
					controller: 'NavbarController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				info: function (InfoService) {
					return InfoService.load();
				}
//				translatePartialLoader: function ($translate, $translatePartialLoader) {
//					$translatePartialLoader.addPart('global');
//				}
			}
		}).state('fullwidth', {
			parent: 'app',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-12'
			}
		}).state('sidebar', {
			parent: 'app',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-10 col-sm-9'
			},
			views: {
				'sidebar@': {
					templateUrl: 'scripts/app/layouts/sidebar/sidebar.html',
					controller: 'SidebarController'
				}
			}
		}).state('footer', {
			parent: 'fullwidth',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-12 content-footer'
			},
			views: {
				'footer@': {
					templateUrl: 'scripts/app/layouts/footer/footer.html',
					controller: 'FooterController'
				}
			},
			resolve: {
				toolbarSettings: function (ObjectUtils) {
					return new ObjectUtils.initToolbarSettings();
				}
			}
		}).state('submenu', {
			parent: 'fullwidth',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-12 content-submenu'
			},
			views: {
				'submenu@': {
					templateUrl: 'scripts/app/layouts/submenu/submenu.html',
					controller: 'SubmenuController'
				}
			},
			resolve: {
				submenuSettings: function (ObjectUtils) {
					return new ObjectUtils.initSubmenuSettings();
				}
			}
		}).state('sidebar-footer', {
			parent: 'sidebar',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-10 col-sm-9 content-footer'
			},
			views: {
				'footer@': {
					templateUrl: 'scripts/app/layouts/footer/footer.html',
					controller: 'FooterController'
				}
			},
			resolve: {
				toolbarSettings: function (ObjectUtils) {
					return new ObjectUtils.initToolbarSettings();
				}
			}
		}).state('sidebar-submenu', {
			parent: 'sidebar',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-10 col-sm-9 content-submenu'
			},
			views: {
				'submenu@': {
					templateUrl: 'scripts/app/layouts/submenu/submenu.html',
					controller: 'SubmenuController'
				}
			},
			resolve: {
				submenuSettings: function (ObjectUtils) {
					return new ObjectUtils.initSubmenuSettings();
				}
			}
		}).state('sidebar-submenu-footer', {
			parent: 'sidebar-footer',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-10 col-sm-9 content-submenu-footer'
			},
			views: {
				'submenu@': {
					templateUrl: 'scripts/app/layouts/submenu/submenu.html',
					controller: 'SubmenuController'
				}
			},
			resolve: {
				submenuSettings: function (ObjectUtils) {
					return new ObjectUtils.initSubmenuSettings();
				}
			}
		});
	}
})();
